import { render, staticRenderFns } from "./TopicDetails.vue?vue&type=template&id=b703d810&scoped=true"
import script from "./TopicDetails.vue?vue&type=script&lang=js"
export * from "./TopicDetails.vue?vue&type=script&lang=js"
import style0 from "./TopicDetails.vue?vue&type=style&index=0&id=b703d810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b703d810",
  null
  
)

export default component.exports